import { defineStore } from "pinia";
import {
  ILanguage,
  MultilingualLanguagesSchema,
  IMultilingualLanguage,
} from "@/schemas/language/languageSchema";
import { iso639 } from "@topol/utils";
import { useNotificationsStore } from "./notifications";

interface State {
  title: string;
  language: ILanguage;
  loadingTemplate: boolean;
  translationInProgress: boolean;
  htmlMinified?: boolean;
  htmlDesktopFirst?: boolean;
  light: boolean;
  metadata: any; //TODO: later to authorization store
  type: string;
  saving: boolean;
  savingAndClosing: boolean;
  sendingTestEmail: boolean;
  sentLimitExceeded: boolean;
  developerModalOpened: boolean;
  renameTemplate?: boolean;
  emailServiceProvider?: "mailchimp" | "sparkpost";
  colorSelecting: boolean;
  clipboardAllowed?: boolean;
  aiLabeledElements?: boolean;
  multilingual?: boolean;
  customLanguagePreset?: {
    name: string;
    code: string;
    nativeName: string;
  }[];
  textEditorToolbarBottomPosition?: "left" | "right" | "center";
  textEditor: "tinymce" | "tiptap";
  uiBlocked: boolean;
}

export const useGeneralStore = defineStore("general", {
  state: (): State => ({
    title: "E-mail editor 3.0",
    language: "en",
    loadingTemplate: false,
    translationInProgress: false,
    htmlMinified: false,
    htmlDesktopFirst: false,
    light: false,
    metadata: null,
    type: "plugin",
    saving: false,
    savingAndClosing: false,
    sendingTestEmail: false,
    sentLimitExceeded: false,
    developerModalOpened: false,
    colorSelecting: false,
    aiLabeledElements: false,
    textEditor: "tinymce",
    uiBlocked: false,
  }),
  getters: {
    isRtlLanguage(): boolean {
      return this.language === "ar" || this.language === "he";
    },
  },
  actions: {
    setCustomLanguagePreset(
      preset: { langs: IMultilingualLanguage; override?: boolean } | undefined
    ) {
      if (!preset) {
        this.customLanguagePreset = undefined;
        return;
      }
      const { data, success } = MultilingualLanguagesSchema.safeParse(
        preset?.langs
      );
      if (!success) {
        const notificationsStore = useNotificationsStore();
        notificationsStore.createNotification({
          type: "error",
          text: "Custom language preset is invalid. Using default languages.",
        });
        return;
      }
      const unique = [
        ...new Map(data.map((item) => [item.code, item])).values(),
      ];
      if (preset.override === false) {
        const defaultLangs = iso639 as IMultilingualLanguage;
        const allLangs = [...defaultLangs, ...unique];
        const uniqueAll = [
          ...new Map(allLangs.map((item) => [item.code, item])).values(),
        ];
        this.customLanguagePreset = uniqueAll;
        return;
      }
      this.customLanguagePreset = unique;
    },
  },
});
